
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutMission from './components/AboutMission';
import AboutTeam from './components/AboutTeam';
import AboutValues from './components/AboutValues';
import AboutHistory from './components/AboutHistory';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  return (
    <div>
      <Header />
      <main>
        <AboutHero />
        <AboutMission />
        <AboutValues />
        <AboutHistory />
        <AboutTeam />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
}
